import { render, staticRenderFns } from "./FixedPatientPanel.vue?vue&type=template&id=d441e504&lang=pug&"
import script from "./FixedPatientPanel.vue?vue&type=script&lang=js&"
export * from "./FixedPatientPanel.vue?vue&type=script&lang=js&"
import style0 from "./FixedPatientPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports